import React from 'react';
import {
    FormBuilder,
    Validators,
    FieldControl,
    FieldGroup
} from "react-reactive-form";
import { withRouter } from 'react-router-dom';
import { swalAlert } from '../../../../lib/Swal.js';
import { callAPI, redirectToLandingPage } from '../../../../lib/Global.js';
import styles from './login.module.css';

class ValidateLoginOtp extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: false };
        this.loginOtpForm.reset({ email: this.props.loginSuccessEmail });
    }

    loginOtpForm = FormBuilder.group({
        email: [null, [Validators.required, Validators.email]],
        securityCode: [null, Validators.required]
    });

    handleSubmitLoginOtp = async (e) => {
        e.preventDefault();

        const r = await callAPI('ValidateLoginOtp', this.loginOtpForm.value);
        this.setState({ isLoading: false });
        this.loginOtpForm.updateValueAndValidity(this.loginOtpForm.value);
        if (r.isLoginOtpValid && r.token) {
            this.props.markAsLogin(JSON.stringify(r.token));
            const route = redirectToLandingPage('client');
            this.props.history.push(route);
        } else {
            const errorMsg = `<span class="text-danger">${r.errorMsg || 'Something went wrong!!!'}</span>`;
            swalAlert('e', errorMsg);
        }

    }

    render() {
        return (
            <>
                <div style={{
                    height: '100vh',
                    position: 'relative',
                    backgroundImage: `url('../img/login-background-img.jpg')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }}>
                    <div style={{
                        position: 'absolute',
                        height: '100%',
                        backgroundColor: 'rgb(0, 0, 0)',
                        width: '100%',
                        opacity: '0.7'
                    }}>
                    </div>
                </div>
                <img src="./img/caring-people-logo.svg" alt="Caring people Logo" className={styles.loginLogoImgStyling} />
                <div className="container d-flex align-items-center flex-column position-absolute top-50 start-50 translate-middle">
                    <div className={`card border-0 py-5 px-3 ${styles.loginCardStyling}`}>
                        <div className="row">
                            <div className="col-12 text-center">
                                <img src="./img/login-header-image.svg" className={`card-img-top ${styles.loginImgStyling}`} alt="..." />
                            </div>
                            <div className="col-12 text-center">
                                <span className={`${styles.loginTitleStyling}`}>Built On Passion and Excellence</span>
                            </div>
                        </div>
                        <div className="card-body">
                            <h3 className="card-title mt-2"><span className={styles.signInLabelStyling}>Verify OTP</span></h3>
                            <footer className="text-muted pb-6" ><span className={styles.contInfinityLabelStyling}>Sent to your email</span> </footer>
                            <form className="row g-3" onSubmit={() => this.handleSubmitLoginOtp}>
                                <FieldGroup
                                    control={this.loginOtpForm}
                                    render={({ invalid, pristine, pending }) => (
                                        <>
                                            <FieldControl
                                                name="securityCode"
                                                render={({ handler, touched, hasError }) => (
                                                    <div className="input-group mb-3">
                                                        <input type="text" className={`form-control rounded-0 ${styles.loginInputStyling} ` + (pristine ? '' : touched && hasError("required") ? 'is-invalid' : 'is-valid')} placeholder="Enter OTP" {...handler()} required />

                                                        <div className="invalid-feedback">
                                                            <span>
                                                                {touched &&
                                                                    hasError("required") &&
                                                                    "OTP is required"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                            <div className="row g-3">
                                                <div className="d-grid gap-2 col-6 mx-auto">
                                                    <button className={`btn ${styles.signInButtonStyling} `} disabled={invalid || pristine || this.state.isLoading} onClick={e => this.handleSubmitLoginOtp(e)}>{this.state.isLoading ? 'Please wait...' : 'Verify'}</button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                />
                            </form>

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(ValidateLoginOtp);